module.exports = __webpack_public_path__ + "static/media/dorp.26a86d41.jpg";